/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserProfileData } from './UserProfileData';
import {
    UserProfileDataFromJSON,
    UserProfileDataFromJSONTyped,
    UserProfileDataToJSON,
    UserProfileDataToJSONTyped,
} from './UserProfileData';

/**
 *
 * @export
 * @interface ProfileUpdateResponse
 */
export interface ProfileUpdateResponse {
    /**
     *
     * @type {boolean}
     * @memberof ProfileUpdateResponse
     */
    success: boolean;
    /**
     *
     * @type {string}
     * @memberof ProfileUpdateResponse
     */
    message: string;
    /**
     *
     * @type {string}
     * @memberof ProfileUpdateResponse
     */
    pendingEmail: string | null;
    /**
     *
     * @type {UserProfileData}
     * @memberof ProfileUpdateResponse
     */
    user: UserProfileData;
}

/**
 * Check if a given object implements the ProfileUpdateResponse interface.
 */
export function instanceOfProfileUpdateResponse(value: object): value is ProfileUpdateResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('pendingEmail' in value) || value['pendingEmail'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    return true;
}

export function ProfileUpdateResponseFromJSON(json: any): ProfileUpdateResponse {
    return ProfileUpdateResponseFromJSONTyped(json, false);
}

export function ProfileUpdateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileUpdateResponse {
    if (json == null) {
        return json;
    }
    return {

        'success': json['success'],
        'message': json['message'],
        'pendingEmail': json['pending_email'],
        'user': UserProfileDataFromJSON(json['user']),
    };
}

  export function ProfileUpdateResponseToJSON(json: any): ProfileUpdateResponse {
      return ProfileUpdateResponseToJSONTyped(json, false);
  }

  export function ProfileUpdateResponseToJSONTyped(value?: ProfileUpdateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'success': value['success'],
        'message': value['message'],
        'pending_email': value['pendingEmail'],
        'user': UserProfileDataToJSON(value['user']),
    };
}
